import React from "react";
import "./Footer.scss";

import logoImage from "../../assets/logo.png";
import LazyImage from "../LazyImage/LazyImage";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation("footer");
  return (
    <div className="footer">
      <div className="footer__content">
        <div className="inner">
          <div className="left">
            <p>{t("footer_text1")}</p>
            <p>{t("footer_text2")}</p>
            <p>{t("footer_text3")}</p>
            <p>{t("footer_text4")}</p>
          </div>
          <div className="center">
            <Link to={"/"} className="logo">
              <LazyImage src={logoImage} alt="Footer logo image" />
            </Link>
          </div>
          <div className="right">
            <p>{t("footer_text5")}</p>
            <p>{t("footer_text6")}</p>
            <p>{t("footer_text7")}</p>
          </div>
        </div>
      </div>
      <div className="footer__copyright">
        <p>&copy; {t("footer_copyright")}</p>
      </div>
    </div>
  );
}
